export default "__VITE_ASSET__$7S4S64v__"